module.exports = __webpack_public_path__ + "img/1hruska.532f505a.jpg";